import { Navigate, useLocation } from "react-router-dom";
import ProjectCompare from "./components/ProjectCompare";
import ProjectResults from "./components/ProjectResults";
import { useAppParams, useAppSelector, usePermissions } from "@app/hooks";
import { selectCurrentBuilder } from "@features/builder/builderSlice";

const ProjectResultsContainer = () => {
	const { projectId } = useAppParams();
	const { isPublic } = usePermissions();
	const location = useLocation();
	const { resultsTab } = useAppSelector(selectCurrentBuilder);

	const isProjectIdValid = projectId !== undefined && projectId !== "new";
	if (!isProjectIdValid) {
		return <Navigate to="/project/new/description" state={{ from: location }} replace />;
	}

	return (
		<>
			<ProjectResults projectId={projectId} resultsTab={resultsTab} />
			{resultsTab === "ghg" && !isPublic ? <ProjectCompare /> : null}
		</>
	);
};

export default ProjectResultsContainer;
